var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgWater = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.309 2c.76 0 1.375.614 1.375 1.375v.516l4.125-.516c.76 0 1.375.614 1.375 1.375 0 .76-.614 1.375-1.375 1.375l-4.125-.516-1.332-.167-.043-.005-.043.005-1.332.167-4.125.516c-.76 0-1.375-.614-1.375-1.375 0-.76.614-1.375 1.375-1.375l4.125.516v-.516c0-.76.614-1.375 1.375-1.375zm-9.625 9.625c0-.76.614-1.375 1.375-1.375h4.125l.971-.971c.258-.258.606-.404.971-.404h.808V6.993l1.375-.172 1.375.172v1.882h.804c.365 0 .713.146.97.404l.976.971h1.375a6.873 6.873 0 0 1 6.875 6.875c0 .76-.614 1.375-1.375 1.375h-2.75c-.76 0-1.375-.614-1.375-1.375 0-.76-.614-1.375-1.375-1.375h-1.551a4.808 4.808 0 0 1-3.949 2.063A4.808 4.808 0 0 1 8.36 15.75H4.06c-.76 0-1.375-.614-1.375-1.375v-2.75zm18.769 8.568a.52.52 0 0 1 .481-.318c.21 0 .395.125.481.318l.782 1.822c.078.176.116.37.116.563v.047c0 .76-.614 1.375-1.375 1.375-.76 0-1.375-.614-1.375-1.375v-.052c0-.193.039-.382.116-.562l.782-1.822-.008.004z",
    fill: "#1A202C",
    fillRule: "nonzero"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWater, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/water.281d58c9.svg";
export { ForwardRef as ReactComponent };